import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

// models
import {Cars} from "../models/cars/cars";
import {Car} from "../models/cars/car";
import {ApiMessage} from "../models/api-message";


@Injectable({
    providedIn: 'root'
})
export class CarsService {

    constructor(protected http: HttpClient) {
    }

    // get all cars form API - only admin
    public index(page?: number, perPage?: number, sort?: string, direction?: string, search?: string, status?: string): Observable<Cars> {

        let url = `${environment.api}/car`;
        if (perPage) url += `?page=${page}&perPage=${perPage}&sort=${sort}&direction=${direction}&search=${search}`;
        if (status) url += `&status=${status}`;

        return this.http.get<Cars>(url);
    }

    // get one car from API - only admin
    public getCar(id: number): Observable<Car> {
        const url = `${environment.api}/car`;
        return this.http.get<Car>(`${url}/${id}`);
    }

    // add/create car in API - only admin
    public createCar(data: Car): Observable<ApiMessage> {
        const url = `${environment.api}/car`;
        return this.http.post<ApiMessage>(url, data);
    }

    // update a car in API - only admin
    public updateCar(id: number, data: Partial<Car>): Observable<ApiMessage> {
        const url = `${environment.api}/car`;
        return this.http.put<ApiMessage>(`${url}/${id}`, data);
    }
}
